export default __webpack_public_path__ + "static/barlow-v4-latin-regular-d216a0a23d2052c84e6fc4f074250c50.woff2";